import {Inject, Injectable} from '@angular/core';
import {L10N_CONFIG, L10nConfig, L10nLocale, L10nStorage} from 'angular-l10n';
import {LocalStorageService} from '../../services/local-storage.service';

@Injectable()
export class L10nStorageService implements L10nStorage {

    private LOCALE_STORAGE_KEY = 'locale';

    constructor(
        private localStorageService: LocalStorageService,

        @Inject(L10N_CONFIG)
        private l10nConfig: L10nConfig
    ) {}

    public read(): Promise<L10nLocale | null> {
        const storedLang = this.localStorageService.get(this.LOCALE_STORAGE_KEY);

        const findLocale = (lang: string) => {
            const schema = this.l10nConfig.schema.find(schemaItem =>
                schemaItem.locale.language === lang
            );

            return schema && schema.locale;
        };

        const locale = storedLang
            && findLocale(storedLang)
            || this.l10nConfig.defaultLocale;

        return Promise.resolve(locale);
    }

    public write(locale: L10nLocale): Promise<void> {
        this.localStorageService.set(this.LOCALE_STORAGE_KEY, locale.language);

        return Promise.resolve(undefined);
    }

}
